export function buildSetupAssistantBootstrapWelcomeMessage(input: {
  agentName: string;
}): string {
  const agentName = normalizeRequiredText(input.agentName, "agentName");

  return [
    `Hi, I’m ${agentName}.`,
    "",
    "This is your WakeLoop Welcoming Space. Ask me about setting up WakeLoop, managing Agent Profiles, and tagging local @agents from a Space. WakeLoop is the WakeLoop: a Space is the shared collaboration surface, an Agent Profile is the AI teammate identity, and WakeLoop Service is the local execution carrier.",
    "",
    "When you want a local agent to do work, tag it with @ here.",
  ].join("\n");
}

function normalizeRequiredText(value: string, fieldName: string): string {
  const normalized = value.trim();
  if (!normalized) {
    throw new Error(`${fieldName} is required`);
  }
  return normalized;
}
